import { createActions } from 'redux-actions'

const Downloads = createActions({ },
  // identity function actions
  'SHOW_FEED_DOWNLOAD_MODAL',
  'HIDE_FEED_DOWNLOAD_MODAL',
  'SHOW_ACCOUNT_DOWNLOAD_MODAL',
  'HIDE_ACCOUNT_DOWNLOAD_MODAL',
)

export default Downloads

